import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Archive from  '@/components/page/Archive';

class ArchivePortal extends Component {
  render() {

    // Container ref
    const targetContainer = document.getElementById('react-archive-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
        <Archive />, targetContainer
    );
  }
}

export default ArchivePortal;